import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CalendarPage } from "@/components/dashboard/calendar/CalendarPage";

const calendarSearchSchema = z.object({
	view: z.enum(["month", "week"]).optional().catch(undefined),
	date: z.string().optional().catch(undefined),
	postId: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/dashboard/calendar")({
	component: CalendarPage,
	validateSearch: (search) => calendarSearchSchema.parse(search),
});
